import React, { useEffect, useState } from 'react';
import { Box } from '@mui/material';
import moment from 'moment-timezone';
import { DEFAULT_START_OFFSET } from '../../calendar-items/CalendarCalculator';
import { useAuth } from '../../../session/InternalAuthProvider';
import { AccountData } from '../../../api';
import { isSummerTime } from '../../../utils/TimeUtils';

export const CurrentTimeDivider = () => {
  const { authState } = useAuth();
  const account = authState.account as unknown as AccountData;

  const calculateCurrentMinutePosition = () => {
    const currentMoment = moment.tz(account.timezone);
    const currentHour = currentMoment.hour();
    const currentMinute = currentMoment.minute();

    const pixelsPerHour = 50;
    const pixelsPerMinute = pixelsPerHour / 60;
    const shouldHaveSummerTimeOffset = isSummerTime(account);
    const totalOffset = shouldHaveSummerTimeOffset ? DEFAULT_START_OFFSET : DEFAULT_START_OFFSET;
    return (currentHour - totalOffset) * pixelsPerHour + currentMinute * pixelsPerMinute;
  };

  const [dividerPosition, setDividerPosition] = useState(calculateCurrentMinutePosition());

  useEffect(() => {
    const interval = setInterval(() => {
      setDividerPosition(calculateCurrentMinutePosition());
    }, 5 * 60 * 1000); // 5 minutes

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <Box
        aria-hidden="true"
        sx={{
          position: 'absolute',
          insetInline: 0,
          top: dividerPosition,
          height: 2,
          bgcolor: 'mb.terracotta',
          zIndex: 200,
          pointerEvents: 'none',
        }}
      />
      <Box
        aria-hidden="true"
        sx={{
          position: 'absolute',
          insetInlineStart: -5,
          top: dividerPosition - 4,
          width: 10,
          height: 10,
          borderRadius: '50%',
          bgcolor: 'mb.terracotta',
          zIndex: 200,
          pointerEvents: 'none',
        }}
      />
    </>
  );
};
